export const BACK_TO_SEARCH = 'Tilbage til søgning...';